import { useEffect, useRef } from "react";
import {
  PAGE_FILTERS_REQUEST_EVENT,
  clearPageFiltersState,
  publishPageFiltersState,
} from "../services/pageFiltersService";

// Liga a página ao funil da barra superior: publica a contagem de filtros aplicados e chama onOpen
// quando o funil é clicado. Ao sair da página, o funil some.
export default function usePageFilters({ count = 0, onOpen }) {
  const onOpenRef = useRef(onOpen);

  useEffect(() => {
    onOpenRef.current = onOpen;
  });

  useEffect(() => {
    publishPageFiltersState({ count });
  }, [count]);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const handleOpen = () => onOpenRef.current?.();
    window.addEventListener(PAGE_FILTERS_REQUEST_EVENT, handleOpen);
    return () => {
      window.removeEventListener(PAGE_FILTERS_REQUEST_EVENT, handleOpen);
      clearPageFiltersState();
    };
  }, []);
}
